module.exports = __webpack_public_path__ + "static/img/5.6b47766.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/5.jpg
// module id = WCTn
// module chunks = 18